import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authClient } from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { store } from 'redux/store';

interface AuthRequestHistoryResponse {
    id: number;
    nickname: string;
    companyCode: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}
interface AuthRequestHistorySlice {
    data: AuthRequestHistoryResponse[];
    loading: boolean;
    error: string;
}

const initialState: AuthRequestHistorySlice = {
    data: [],
    loading: false,
    error: '',
};
interface SearchAuthRequestPayload {
    offset?: number;
    pageSize: number;
    nickname?: string;
    createdAtFrom?: string;
    createdAtTo?: string;
    updatedAtFrom?: string;
    updatedAtTo?: string;
    paymentToken?: string;
    externalId?: string;
    isActive?: boolean;
}

export const searchPaymentAuthRequestHistory = createAsyncThunk(
    'authRequest/searchPaymentAuthRequestHistory',
    async (payload: SearchAuthRequestPayload) => {
        const companyCode = store.getState().user.userInfo?.companyCode;

        const response: any = await authClient.post(
            `${oldGloryBaseUrl}/merchant/searchPaymentAuthRequestHistory`,
            {
                ...payload,
            },
            {
                'Content-Type': 'application/json',
                companyCode,
            }
        );

        return response?.history || [];
    }
);

export const fetchAuthRequest = createAsyncThunk('secretInfo/fetchSecretInfo', async () => {
    const companyCode = store.getState().user.userInfo?.companyCode;
    const response: any = await authClient.get(`${oldGloryBaseUrl}/merchant/getAuthRequestHistory`, {
        headers: {
            companyCode,
        },
    });
    return response?.history;
});

const authRequestSlice = createSlice({
    name: 'authRequest',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAuthRequest.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAuthRequest.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload;
        });
        builder.addCase(fetchAuthRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Something went wrong';
        });
    },
});

export const fetchAuthRequestDetails = async (id: number) => {
    const companyCode = store.getState().user.userInfo?.companyCode;
    const response: any = await authClient.get(`${oldGloryBaseUrl}/merchant/getAuthRequest/${id}`, {
        headers: {
            companyCode,
        },
    });
    return response;
};

export default authRequestSlice.reducer;
